<template>
  <div>
    <b-modal
      id="modal-organization"
      ref="modal_organization"
      :title="title"
      size="xl"
      modal-class="custom-modal"
      lazy
      centered
      scrollable
      no-close-on-backdrop
      no-close-on-esc
      @hidden="onHidden"
    >
      <b-skeleton-wrapper :loading="isBusy">
        <template #loading>
          <b-form>
            <b-card bg-variant="light">
              <!-- ИНН, КПП, ОГРН -->
              <b-row class="mt-2">
                <b-col>
                  <b-skeleton width="10%" height="24%" class="mb-2"/>
                  <b-skeleton type="input" height="41%"/>
                </b-col>
                <b-col>
                  <b-skeleton width="10%" height="24%" class="mb-2"/>
                  <b-skeleton type="input" height="41%"/>
                </b-col>
                <b-col>
                  <b-skeleton width="10%" height="24%" class="mb-2"/>
                  <b-skeleton type="input" height="41%"/>
                </b-col>
              </b-row>
              <!-- Заполнить данными -->
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="16%" height="115%"/>
                </b-col>
              </b-row>
              <!--Сокращённое, полное наименование заказчика -->
              <b-row>
                <b-col>
                  <b-skeleton width="20%" height="17%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="29%" class="mb-2"/>
                  <b-skeleton width="30%" height="13%"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-skeleton width="15%" height="17%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="29%" class="mb-2"/>
                  <b-skeleton width="26%" height="13%"/>
                </b-col>
              </b-row>
              <!-- Адрес, Телефон, Примечание -->
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="4%" height="26%" class="mb-2"/>
                  <b-skeleton type="input" height="41%"/>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="6%" height="26%" class="mb-2"/>
                  <b-skeleton type="input" height="41%"/>
                </b-col>
              </b-row>
              <b-row class="mb-5">
                <b-col>
                  <b-skeleton width="9%" height="26%" class="mb-2"/>
                  <b-skeleton type="input" height="104%"/>
                </b-col>
              </b-row>
              <!-- Банковские реквизиты -->
              <b-row class="mb-1">
                <b-col>
                  <b-skeleton width="15%" height="55%"/>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="6%" height="26%" class="mb-2"/>
                  <b-skeleton type="input" height="41%"/>
                </b-col>
                <b-col>
                  <b-skeleton width="49%" height="26%" class="mb-2"/>
                  <b-skeleton type="input" height="41%"/>
                </b-col>
              </b-row>
              <b-row class="mb-3">
                <b-col>
                  <b-skeleton width="19%" height="26%" class="mb-2"/>
                  <b-skeleton type="input" height="41%"/>
                </b-col>
                <b-col>
                  <b-skeleton width="28%" height="26%" class="mb-2"/>
                  <b-skeleton type="input" height="41%"/>
                </b-col>
              </b-row>
              <!-- Руководители организации или ИП -->
              <b-row class="mb-0">
                <b-col>
                  <b-skeleton width="35%" height="50%" class="mb-2"/>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="43%" height="21%" class="mb-2"/>
                  <b-skeleton type="input" height="50%"/>
                </b-col>
                <b-col>
                  <b-skeleton width="26%" height="21%" class="mb-2"/>
                  <b-skeleton type="input" height="50%"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="4">
                  <b-skeleton width="30%" height="21%" class="mb-2"/>
                  <b-skeleton type="input" height="50%"/>
                </b-col>
                <b-col>
                  <b-skeleton width="20%" height="21%" class="mb-2"/>
                  <b-skeleton type="input" height="50%"/>
                </b-col>
                <b-col>
                  <b-skeleton width="20%" height="21%" class="mb-2"/>
                  <b-skeleton type="input" height="50%"/>
                </b-col>
              </b-row>
            </b-card>
          </b-form>
        </template>

        <template #default>
          <b-form>
            <div class="custom-collapse-group">
              <div class="custom-collapse-header" v-b-toggle.collapse-organization-details role="button">
                <v-icon name="buttons/collapse_chevrons_down" :size="13" class="chevron-icon"/>
                <span class="custom-collapse-header-title">Реквизиты компании</span>
              </div>
              <b-collapse id="collapse-organization-details" visible>
                <div class="custom-collapse-body">
                  <b-row cols="3">
                    <b-col>
                      <b-form-group id="group-inn" :label="$t('message.organizations.modal.inn')">
                        <b-form-input
                          type="text"
                          size="sm"
                          :disabled="isDisabled"
                          :state="getFieldState('inn')"
                          placeholder="Введите ИНН"
                          v-model="newItem.inn"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group id="group-kpp" :label="$t('message.organizations.modal.kpp')">
                        <b-form-input
                          type="text"
                          size="sm"
                          :disabled="isDisabled"
                          placeholder="Введите КПП"
                          v-model="newItem.kpp"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group id="group-ogrn" :label="$t('message.organizations.modal.ogrn')">
                        <b-form-input
                          type="text"
                          size="sm"
                          :disabled="isDisabled"
                          placeholder="Введите ОГРН"
                          v-model="newItem.ogrn"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-button class="custom-btn-secondary mb-2 mt-1" :disabled="isEmpty(newItem.inn) || isDisabled || isLookingUpParty" @click="findCustomerData()">
                    <v-icon name="buttons/fill" :size="13"/>
                    Заполнить данными
                  </b-button>
                  <b-row>
                    <b-col cols="8">
                      <b-form-group label="Полное наименование">
                        <b-form-input
                          type="text"
                          size="sm"
                          :disabled="isDisabled"
                          v-model="newItem.full_name"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="4">
                      <b-form-group label="Сокращённое наименование">
                        <b-form-input
                          type="text"
                          size="sm"
                          :disabled="isDisabled"
                          :state="getFieldState('name')"
                          v-model="newItem.name"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="8">
                      <b-form-group label="Юридический адрес">
                        <b-form-input
                          type="text"
                          size="sm"
                          :disabled="isDisabled"
                          :placeholder="$t('message.organizations.modal.addressPlaceholder')"
                          v-model="newItem.address"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="4">
                      <b-form-group label="Контактный телефон">
                        <b-input-group size="sm" :prepend="phoneInputPrefix(newItem.phone)">
                          <b-form-input
                            type="tel"
                            size="sm"
                            :disabled="isDisabled"
                            :placeholder="$t('message.organizations.modal.phonePlaceholder')"
                            v-model="newItem.phone"
                          />
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-form-group label="Описание">
                    <b-form-textarea
                      size="sm"
                      :disabled="isDisabled"
                      :placeholder="$t('message.organizations.modal.descriptionPlaceholder')"
                      v-model="newItem.description"
                      :rows="3"
                      :max-rows="6"
                    />
                  </b-form-group>
                </div>
              </b-collapse>
            </div>

            <div class="custom-collapse-group">
              <div class="custom-collapse-header" v-b-toggle.collapse-organization-bank-details role="button">
                <v-icon name="buttons/collapse_chevrons_down" :size="13" class="chevron-icon"/>
                <span class="custom-collapse-header-title">Банковские реквизиты</span>
              </div>
              <b-collapse id="collapse-organization-bank-details" visible>
                <div class="custom-collapse-body">
                  <b-row cols="2" class="align-items-end">
                    <b-col>
                      <b-form-group id="group-bik" :label="$t('message.organizations.modal.bik')">
                        <b-form-input
                          size="sm"
                          autocomplete="off"
                          :disabled="isDisabled"
                          v-model="newItem.bik"
                        />
                      </b-form-group>

                      <b-form-group id="group-cor-account" :label="$t('message.organizations.modal.cor_account')">
                        <b-form-input
                          size="sm"
                          autocomplete="off"
                          :disabled="isDisabled"
                          v-model="newItem.cor_account"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group id="group-bank" :label="$t('message.organizations.modal.bank')">
                        <b-form-input
                          id="input-bank"
                          size="sm"
                          autocomplete="off"
                          :disabled="isDisabled"
                          v-model="newItem.bank"
                        />
                      </b-form-group>

                      <b-form-group id="group-checking-account" :label="$t('message.organizations.modal.checking_account')">
                        <b-form-input
                          id="input-checking-account"
                          size="sm"
                          autocomplete="off"
                          :disabled="isDisabled"
                          v-model="newItem.checking_account"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>
              </b-collapse>
            </div>

            <div class="custom-collapse-group">
              <div class="custom-collapse-header" v-b-toggle.collapse-organization-executive role="button">
                <v-icon name="buttons/collapse_chevrons_down" :size="13" class="chevron-icon"/>
                <span class="custom-collapse-header-title">Руководители организации или ИП для документов</span>
              </div>
              <b-collapse id="collapse-organization-executive" visible>
                <div class="custom-collapse-body">
                  <b-row cols="2" class="align-items-end">
                    <b-col>
                      <b-form-group id="group-director" :label="$t('message.organizations.modal.director')">
                        <b-form-input
                          size="sm"
                          autocomplete="off"
                          :disabled="isDisabled"
                          v-model="newItem.director"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group id="group-accountant" :label="$t('message.organizations.modal.accountant')">
                        <b-form-input
                          size="sm"
                          autocomplete="off"
                          :disabled="isDisabled"
                          v-model="newItem.accountant"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>
              </b-collapse>
            </div>

            <div class="custom-collapse-group">
              <div class="custom-collapse-header" v-b-toggle.collapse-organization-integrations role="button">
                <v-icon name="buttons/collapse_chevrons_down" :size="13" class="chevron-icon"/>
                <span class="custom-collapse-header-title">Интеграции</span>
              </div>

              <b-collapse id="collapse-organization-integrations" visible>
                <div class="custom-collapse-body">
                  <b-row class="align-items-end">
                    <b-col cols="4">
                      <b-form-group id="group-balans-pro" label="Баланс Про API токен">
                        <b-form-input
                          type="password"
                          size="sm"
                          autocomplete="off"
                          :disabled="isDisabled"
                          :placeholder="integrations.balans_pro_configured ? 'Токен сохранён' : ''"
                          v-model="integrations.balans_pro_org_token"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="4">
                      <b-form-group id="group-avito-client-id" label="Авито Client id">
                        <b-form-input
                          size="sm"
                          autocomplete="off"
                          :disabled="isDisabled"
                          v-model="integrations.avito_client_id"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="4">
                      <b-form-group id="group-avito-client-secret" label="Авито Client secret">
                        <b-form-input
                          type="password"
                          size="sm"
                          autocomplete="off"
                          :disabled="isDisabled"
                          :placeholder="integrations.avito_configured ? 'Секрет сохранён' : ''"
                          v-model="integrations.avito_client_secret"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>
              </b-collapse>
            </div>

            <div class="custom-collapse-group">
              <div class="custom-collapse-header" v-b-toggle.collapse-organization-signatures role="button">
                <v-icon name="buttons/collapse_chevrons_down" :size="13" class="chevron-icon"/>
                <span class="custom-collapse-header-title">Логотип, печать и подписи</span>
              </div>

              <b-collapse id="collapse-organization-signatures" visible>
                <div class="custom-collapse-body">
                  <b-tabs card class="custom-tabs">
                    <b-tab active title="Логотип">
                      <div class="upload-zone" :class="{ 'is-muted': !!logoFile }">
                        <div class="upload-main-content">
                          <v-icon name="buttons/inbox" :size="32"/>
                          <div class="d-flex flex-column ml-2">
                            <span class="font-weight-bold text-dark">Перетяните файлы в эту область</span>
                            <small class="text-muted">или нажмите, чтобы выбрать файл</small>
                          </div>
                        </div>
                        <div class="upload-meta">
                          <div class="d-flex flex-column text-right leading-tight">
                            <small class="text-muted" style="font-size: 12px;">РАЗМЕР, ММ</small>
                            <span class="text-muted">54х27</span>
                          </div>
                          <div v-if="logoFile" class="upload-preview-container">
                            <div class="preview-frame">
                              <img :src="logoBlobURL" alt="Preview" class="preview-img">
                              <v-icon name="buttons/trash" :size="20" class="delete-icon ml-2" @click.stop="onRemove('logoFile')"/>
                            </div>
                          </div>
                        </div>
                        <b-form-file v-model="logoFile" plain accept="image/jpeg, image/png" class="hidden-file-input" :disabled="isDisabled"/>
                      </div>
                    </b-tab>
                    <b-tab title="Печать">
                      <div class="upload-zone" :class="{ 'is-muted': !!stampFile }">
                        <div class="upload-main-content">
                          <v-icon name="buttons/inbox" :size="32"/>
                          <div class="d-flex flex-column ml-2">
                            <span class="font-weight-bold text-dark">Перетяните файлы в эту область</span>
                            <small class="text-muted">или нажмите, чтобы выбрать файл</small>
                          </div>
                        </div>
                        <div class="upload-meta">
                          <div class="d-flex flex-column text-right leading-tight">
                            <small class="text-muted" style="font-size: 12px;">РАЗМЕР, ММ</small>
                            <span class="text-muted">40x40</span>
                          </div>
                          <div v-if="stampFile" class="upload-preview-container">
                            <div class="preview-frame">
                              <img :src="stampBlobURL" alt="Preview" class="preview-img">
                              <v-icon name="buttons/trash" :size="20" class="delete-icon ml-2" @click.stop="onRemove('stampFile')"/>
                            </div>
                          </div>
                        </div>
                        <b-form-file v-model="stampFile" plain accept="image/jpeg, image/png" class="hidden-file-input" :disabled="isDisabled"/>
                      </div>
                    </b-tab>
                    <b-tab title="Подпись руководителя">
                      <div class="upload-zone" :class="{ 'is-muted': !!directorSignFile }">
                        <div class="upload-main-content">
                          <v-icon name="buttons/inbox" :size="32"/>
                          <div class="d-flex flex-column ml-2">
                            <span class="font-weight-bold text-dark">Перетяните файлы в эту область</span>
                            <small class="text-muted">или нажмите, чтобы выбрать файл</small>
                          </div>
                        </div>
                        <div class="upload-meta">
                          <div class="d-flex flex-column text-right leading-tight">
                            <small class="text-muted" style="font-size: 12px;">РАЗМЕР, ММ</small>
                            <span class="text-muted">34x16</span>
                          </div>
                          <div v-if="directorSignFile" class="upload-preview-container">
                            <div class="preview-frame">
                              <img :src="directorSignBlobURL" alt="Preview" class="preview-img">
                              <v-icon name="buttons/trash" :size="20" class="delete-icon ml-2" @click.stop="onRemove('stampFile')"/>
                            </div>
                          </div>
                        </div>
                        <b-form-file v-model="directorSignFile" plain accept="image/jpeg, image/png" class="hidden-file-input" :disabled="isDisabled"/>
                      </div>
                    </b-tab>
                    <b-tab title="Подпись бухгалтера">
                      <div class="upload-zone" :class="{ 'is-muted': !!accountantSignFile }">
                        <div class="upload-main-content">
                          <v-icon name="buttons/inbox" :size="32"/>
                          <div class="d-flex flex-column ml-2">
                            <span class="font-weight-bold text-dark">Перетяните файлы в эту область</span>
                            <small class="text-muted">или нажмите, чтобы выбрать файл</small>
                          </div>
                        </div>
                        <div class="upload-meta">
                          <div class="d-flex flex-column text-right leading-tight">
                            <small class="text-muted" style="font-size: 12px;">РАЗМЕР, ММ</small>
                            <span class="text-muted">34x16</span>
                          </div>
                          <div v-if="accountantSignFile" class="upload-preview-container">
                            <div class="preview-frame">
                              <img :src="accountantSignBlobURL" alt="Preview" class="preview-img">
                              <v-icon name="buttons/trash" :size="20" class="delete-icon ml-2" @click.stop="onRemove('stampFile')"/>
                            </div>
                          </div>
                        </div>
                        <b-form-file v-model="accountantSignFile" plain accept="image/jpeg, image/png" class="hidden-file-input" :disabled="isDisabled"/>
                      </div>
                    </b-tab>
                    <b-tab title="Подпись ИП">
                      <div class="upload-zone" :class="{ 'is-muted': !!individualSignFile }">
                        <div class="upload-main-content">
                          <v-icon name="buttons/inbox" :size="32"/>
                          <div class="d-flex flex-column ml-2">
                            <span class="font-weight-bold text-dark">Перетяните файлы в эту область</span>
                            <small class="text-muted">или нажмите, чтобы выбрать файл</small>
                          </div>
                        </div>
                        <div class="upload-meta">
                          <div class="d-flex flex-column text-right leading-tight">
                            <small class="text-muted" style="font-size: 12px;">РАЗМЕР, ММ</small>
                            <span class="text-muted">34x16</span>
                          </div>
                          <div v-if="individualSignFile" class="upload-preview-container">
                            <div class="preview-frame">
                              <img :src="individualSignBlobURL" alt="Preview" class="preview-img">
                              <v-icon name="buttons/trash" :size="20" class="delete-icon ml-2" @click.stop="onRemove('stampFile')"/>
                            </div>
                          </div>
                        </div>
                        <b-form-file v-model="individualSignFile" plain accept="image/jpeg, image/png" class="hidden-file-input" :disabled="isDisabled"/>
                      </div>
                    </b-tab>
                  </b-tabs>
                </div>
              </b-collapse>
            </div>
          </b-form>
        </template>
      </b-skeleton-wrapper>

      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button class="custom-btn-secondary mr-2" @click="handleCancel">
            Отменить
          </b-button>
          <b-button class="custom-btn-primary" :disabled="isDisabled || loading" @click="handleOk">
            <b-spinner v-if="loading" small/>
            Сохранить
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import partyLookup from "../../network/partyLookup";
import organizations from "../../network/organizations";
import balansPro from "../../network/balansPro";
  import helpers from "../../utilites/helpers";

export default {
  name: "Organization",
  mixins: [
    partyLookup,
    organizations, balansPro,
    helpers
  ],
  data() {
    return {
      title:'Организация',
      formUrl: 'organizations',
      newItem: this.setNewItem(),
      integrations: {
        id: null,
        balans_pro_org_token: '',
        balans_pro_configured: false,
        avito_client_id: '',
        avito_client_secret: '',
        avito_configured: false,
        active: true
      },
      deleteRow: {
        id: null,
        name: '',
      },
      isDisabled: true,
      isBusy: false,
      loading: false,
      isBusyStamps: false,
      logoFile: null,
      stampFile: null,
      directorSignFile: null,
      accountantSignFile: null,
      individualSignFile: null,
    }
  },
  computed: {
    logoBlobURL() {
      return this.blobURLFromFile(this.logoFile);
    },
    stampBlobURL() {
      return this.blobURLFromFile(this.stampFile);
    },
    directorSignBlobURL() {
      return this.blobURLFromFile(this.directorSignFile);
    },
    accountantSignBlobURL() {
      return this.blobURLFromFile(this.accountantSignFile);
    },
    individualSignBlobURL() {
      return this.blobURLFromFile(this.individualSignFile);
    },
  },
  methods: {
    setNewItem() {
      this.logoFile = null;
      this.stampFile = null;
      this.directorSignFile = null;
      this.accountantSignFile = null;
      this.individualSignFile = null;

      this.integrations = {
        id: null,
        balans_pro_org_token: '',
        balans_pro_configured: false,
        avito_client_id: '',
        avito_client_secret: '',
        avito_configured: false,
        active: true
      };

      return {
        id: null,
        name: '',
        phone: '',
        address: '',
        active: true,
        description: '',
        inn: '',
        kpp: '',
        ogrn: '',
        full_name: '',
        bik: '',
        bank: '',
        cor_account: '',
        checking_account: '',
        director: '',
        accountant: '',
        stamp: {
          id: 0,
          logo: '',
          stamp: '',
          director_sign: '',
          accountant_sign: '',
          individual_sign: '',
        },
      }
    },
    async showModal(organizationId, isView) {
      this.isDisabled = isView;
      this.newItem = this.setNewItem();
      this.$refs.modal_organization.show();

      if (organizationId) {
        await this.getOrganization(organizationId);
      }
    },
    hideModal() {
      this.$refs.modal_organization.hide();
    },
    handleOk() {
      this.handleSubmit();
    },
    handleCancel() {
      this.hideModal();
    },
    onHidden() {
      this.$emit('modal-closed');
    },
    async getOrganization(organizationId) {
      this.isBusy = true;
      this.loading = true;

      const result = await this.getOrganizationById(organizationId);

      if (!result || !result.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        this.isBusy = false;
        this.loading = false;
        return;
      }

      this.newItem = result.data;

      this.isBusyStamps = true;
      await this.getOrganizationStumps(this.newItem.id);
      this.isBusyStamps = false;

      await this.getIntegrationsData(this.newItem.id);

      this.isBusy = false;
      this.loading = false;
    },
    async getOrganizationStumps(organizationId) {
      const stampsResult = await this.getStamps(organizationId);

      if (stampsResult.data !== null) {
        this.newItem.stamp = stampsResult.data;

        if (this.newItem.stamp.logo !== '') {
          const fileName = this.newItem.stamp.logo.split("/").pop();
          const result = await this.getOrganizationFile(this.newItem.id, "logo");
          this.logoFile = new File([result.data], fileName);
        }
        if (this.newItem.stamp.stamp !== '') {
          const fileName = this.newItem.stamp.logo.split("/").pop();
          const result = await this.getOrganizationFile(this.newItem.id, "stamp");
          this.stampFile = new File([result.data], fileName);
        }
        if (this.newItem.stamp.director_sign !== '') {
          const fileName = this.newItem.stamp.logo.split("/").pop();
          const result = await this.getOrganizationFile(this.newItem.id, "director");
          this.directorSignFile = new File([result.data], fileName);
        }
        if (this.newItem.stamp.accountant_sign !== '') {
          const fileName = this.newItem.stamp.logo.split("/").pop();
          const result = await this.getOrganizationFile(this.newItem.id, "accountant");
          this.accountantSignFile = new File([result.data], fileName);
        }
        if (this.newItem.stamp.individual_sign !== '') {
          const fileName = this.newItem.stamp.logo.split("/").pop();
          const result = await this.getOrganizationFile(this.newItem.id, "individual");
          this.individualSignFile = new File([result.data], fileName);
        }
      }
    },
    async handleSubmit() {
      const submitValidation = [
        { item: 'inn', message: 'Укажите ИНН.' },
        { item: 'name', message: 'Укажите сокращённое наименование заказчика.' },
      ];

      for (const validation of submitValidation) {
        if (!this.newItem[validation.item]) {
          this.showSubmitError(validation.message);
          return;
        }
      }

      this.loading = true;

      const data = { ...this.newItem };

      const method = (data.id > 0) ? this.putOrganization : this.postOrganization;
      const result = await method(data);

      if (result.status === 422) {
        this.showSubmitError("Организация с таким ИНН уже существует. Найдите его в базе или введите корректный ИНН.");
        this.loading = false;
        return;
      }

      if (!result || !result.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        this.loading = false;
        return;
      }

      this.newItem.id = result.data.id;

      await this.sendFiles(this.newItem.id);

      await this.submitIntegrationsData(this.newItem.id);

      this.loading = false;
      this.$emit('refresh');
      this.hideModal();
    },
    getFieldState(field) {
      const value = this.newItem[field];

      if (Array.isArray(value)) {
        return value.length > 0;
      }

      if (typeof value === 'number') {
        return value > 0;
      }

      return !!value;
    },
    // Files
    async sendFiles(organizationId) {
      let formData = new FormData();
      if (this.logoFile) {
        const type = "logo";
        const fileName = this.getFileName(this.logoFile, type);
        formData.append(type, this.logoFile, fileName);
      }

      if (this.stampFile) {
        const type = "stamp";
        const fileName = this.getFileName(this.stampFile, type);
        formData.append(type, this.stampFile, fileName);
      }

      if (this.directorSignFile) {
        const type = "director";
        const fileName = this.getFileName(this.directorSignFile, type);
        formData.append(type, this.directorSignFile, fileName);
      }

      if (this.accountantSignFile) {
        const type = "accountant";
        const fileName = this.getFileName(this.accountantSignFile, type);
        formData.append(type, this.accountantSignFile, fileName);
      }

      if (this.individualSignFile) {
        const type = "individual";
        const fileName = this.getFileName(this.individualSignFile, type);
        formData.append(type, this.individualSignFile, fileName);
      }

      const filesResult = await this.postOrganizationFiles(organizationId, formData)

      if (filesResult.error) {
        this.showSubmitError("Ошибка отправки файлов.");
      }
    },
    onRemove(fileType) {
      const title = "Удаление файла";
      const message = "Вы действительно хотите удалить этот файл?";
      this.showModalDelete(title, message, async () => {
        this[fileType] = null;
      });
    },
    getFileName(file, type) {
      const ext = "." + file.name.split('.').pop();
      return type + ext;
    },
    findCustomerData() {
      return this.fillPartyByINN('organizations');
    },
    blobURLFromFile(file) {
      if (file !== null) {
        return URL.createObjectURL(file);
      }
      return '';
    },
    // Integration
    async getIntegrationsData(organizationId) {
      const result = await this.getOrganizationIntegrations(organizationId);

      if (!result || !result.data) {
        this.loading = false;
        this.isBusy = false;
        return;
      }

      this.integrations = {
        ...this.integrations,
        ...result.data,
        balans_pro_org_token: '',
        avito_client_secret: ''
      };
    },
    async submitIntegrationsData(organizationId) {
      const hasData = this.integrations.balans_pro_configured || this.integrations.avito_configured ||
        this.integrations.balans_pro_org_token || this.integrations.avito_client_id || this.integrations.avito_client_secret;

      if (!this.integrations.id && !hasData) {
        return;
      }

      const data = {
        id: this.integrations.id,
        organization_id: organizationId,
        balans_pro_org_token: this.integrations.balans_pro_org_token,
        avito_client_id: this.integrations.avito_client_id,
        avito_client_secret: this.integrations.avito_client_secret,
        active: this.integrations.active
      };

      const method = (this.integrations.id > 0) ? this.putOrganizationIntegrations : this.postOrganizationIntegrations;
      const result = await method(data);

      if (!result || !result.data) {
        this.showError("Не удалось сохранить данные интеграций.");
        this.loading = false;
      }
    },
  },
}
</script>

<style>
.upload-zone {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  padding: 0 16px;
  border: 1px dashed #ced4da;
  background-color: white;
  border-radius: 4px;
  position: relative;
  transition: background-color 0.2s;
  overflow: hidden;
}

.upload-zone:hover {
  background-color: #f8f9fa;
}

.upload-zone.is-muted .upload-main-content,
.upload-zone.is-muted .upload-dimensions {
  opacity: 0.5;
}

.upload-main-content {
  display: flex;
  align-items: center;
  gap: 12px;
  pointer-events: none;
}

.upload-meta {
  display: flex;
  align-items: center;
  gap: 24px;
  z-index: 2;
}

.upload-preview-container {
  display: flex;
  align-items: center;
  height: 100%;
}

.preview-frame {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 100%;
}

.preview-img {
  max-height: 60px;
  max-width: 120px;
  object-fit: contain;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.hidden-file-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: 1;
}

.delete-icon {
  position: relative;
  z-index: 10;
  cursor: pointer;
  color: #dc3545;
  transition: transform 0.1s;
}

.delete-icon:hover {
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/components/Organizations/Organization.vue